(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('.product-single__scroll-cue').forEach(function (cue) {
    function dismiss() {
      // Hide after a second of scrolling, to avoid accidental dismissal from a small scroll
      // And only if it's in the viewport, so it doesn't get dismissed if the shopper scrolls down to the story and then back up to the buy box
      if ((cue.getBoundingClientRect().top + 200)> window.innerHeight ) {
        return;
      } 
        
      cue.classList.add('is-dismissed');
      window.removeEventListener('scroll', dismiss);
    }

    window.addEventListener('scroll', dismiss, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-game-chapter"] && !Shopify.designMode) return;
  try {
    
  class GameChapterSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-game-chapter-track]');
      this.slides = Array.from(this.querySelectorAll('[data-game-chapter-slide]'));
      this.prevButton = this.querySelector('[data-game-chapter-prev]');
      this.nextButton = this.querySelector('[data-game-chapter-next]');
      this.dots = Array.from(this.querySelectorAll('[data-game-chapter-dot]'));

      if (!this.track || this.slides.length < 2) return;

      this.index = 0;
      this.onScroll = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.syncIndex());
      };
      this.onBlockSelect = (event) => {
        const index = this.slides.findIndex((slide) => slide.contains(event.target));
        if (index > -1) this.goTo(index, 'auto');
      };
      this.onPrev = () => this.goTo(this.index - 1);
      this.onNext = () => this.goTo(this.index + 1);
      this.onDot = (event) => this.goTo(Number(event.currentTarget.dataset.gameChapterDot));

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.prevButton?.addEventListener('click', this.onPrev);
      this.nextButton?.addEventListener('click', this.onNext);
      this.dots.forEach((dot) => dot.addEventListener('click', this.onDot));

      this.updateControls();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.track?.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.prevButton?.removeEventListener('click', this.onPrev);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.dots?.forEach((dot) => dot.removeEventListener('click', this.onDot));
    }

    goTo(index, behavior) {
      const target = Math.max(0, Math.min(index, this.slides.length - 1));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.track.scrollTo({
        left: this.slides[target].offsetLeft,
        behavior: behavior || (reduceMotion ? 'auto' : 'smooth'),
      });
    }

    syncIndex() {
      const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
      if (index === this.index) return;

      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      this.updateControls();
    }

    updateControls() {
      if (this.prevButton) this.prevButton.disabled = this.index === 0;
      if (this.nextButton) this.nextButton.disabled = this.index === this.slides.length - 1;

      this.dots.forEach((dot, i) => {
        if (i === this.index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }
  }

  if (!customElements.get('game-chapter-slider')) {
    customElements.define('game-chapter-slider', GameChapterSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-gift-finder"] && !Shopify.designMode) return;
  try {
    
  class GiftFinderQuiz extends HTMLElement {
    connectedCallback() {
      this.steps = Array.from(this.querySelectorAll('[data-gift-finder-step]'));
      this.currentIndex = 0;
      this.stepAnswers = {};

      this.nextButton = this.querySelector('[data-gift-finder-next]');
      this.backButton = this.querySelector('[data-gift-finder-back]');
      this.dotsContainer = this.querySelector('[data-gift-finder-dots]');
      this.progressLabel = this.querySelector('[data-gift-finder-progress-label]');
      this.announce = this.querySelector('[data-gift-finder-announce]');

      if (!this.steps.length || !this.nextButton) return;

      this.steps.forEach((step, index) => {
        step.hidden = index !== 0;
        step.querySelectorAll('[data-gift-finder-answer]').forEach((answerEl) => {
          answerEl.addEventListener('click', () => this.selectAnswer(step, answerEl));
        });
      });

      if (this.dotsContainer) {
        this.steps.forEach(() => {
          const dot = document.createElement('span');
          dot.className = 'gift-finder__dot';
          this.dotsContainer.appendChild(dot);
        });
      }

      this.nextButton.addEventListener('click', () => this.advance());
      this.backButton?.addEventListener('click', () => this.goBack());

      this.updateProgress();
    }

    selectAnswer(step, answerEl) {
      step.querySelectorAll('[data-gift-finder-answer]').forEach((el) => {
        el.setAttribute('aria-pressed', el === answerEl ? 'true' : 'false');
      });

      // Replace (not merge into) this step's contribution, so re-answering
      // after Back can't leave a stale filter value from the old answer.
      const stepIndex = this.steps.indexOf(step);
      this.stepAnswers[stepIndex] = {
        players: this.splitValues(answerEl.dataset.playersValue),
        age: this.splitValues(answerEl.dataset.ageValue),
        time: this.splitValues(answerEl.dataset.timeValue),
      };

      this.nextButton.disabled = false;
    }

    advance() {
      if (this.currentIndex === this.steps.length - 1) {
        this.redirect();
        return;
      }

      this.steps[this.currentIndex].hidden = true;
      this.currentIndex += 1;
      this.steps[this.currentIndex].hidden = false;
      this.nextButton.disabled = !this.hasAnswerFor(this.currentIndex);
      this.updateProgress();
      this.steps[this.currentIndex].querySelector('.gift-finder__question')?.focus();
    }

    goBack() {
      if (this.currentIndex === 0) return;

      this.steps[this.currentIndex].hidden = true;
      this.currentIndex -= 1;
      this.steps[this.currentIndex].hidden = false;
      this.nextButton.disabled = !this.hasAnswerFor(this.currentIndex);
      this.updateProgress();
      this.steps[this.currentIndex].querySelector('.gift-finder__question')?.focus();
    }

    hasAnswerFor(index) {
      return !!this.steps[index].querySelector('[data-gift-finder-answer][aria-pressed="true"]');
    }

    splitValues(value) {
      return value
        ? value
            .split(',')
            .map((v) => v.trim())
            .filter(Boolean)
        : [];
    }

    updateProgress() {
      const total = this.steps.length;
      const current = this.currentIndex + 1;
      const isLast = this.currentIndex === total - 1;

      if (this.backButton) {
        this.backButton.hidden = this.currentIndex === 0;
      }

      this.nextButton.textContent = isLast ? this.nextButton.dataset.finalLabel : this.nextButton.dataset.nextLabel;

      if (this.dotsContainer) {
        Array.from(this.dotsContainer.children).forEach((dot, index) => {
          dot.dataset.active = index <= this.currentIndex ? 'true' : 'false';
        });
      }

      if (this.progressLabel) {
        const template = this.progressLabel.dataset.template || '';
        this.progressLabel.textContent = template.replace('__CURRENT__', current).replace('__TOTAL__', total);
      }

      if (this.announce) {
        const heading = this.steps[this.currentIndex].querySelector('.gift-finder__question');
        this.announce.textContent = `${this.progressLabel ? this.progressLabel.textContent : ''} ${
          heading ? heading.textContent : ''
        }`;
      }
    }

    redirect() {
      const baseUrl = this.dataset.redirectUrl;
      if (!baseUrl) return;

      const paramMap = {
        players: this.dataset.playersParam,
        age: this.dataset.ageParam,
        time: this.dataset.timeParam,
      };

      // Merge every step's contribution, keeping only non-empty value lists
      // so a step that doesn't set a given filter can't blank out one set
      // by an earlier step.
      const answers = {};
      Object.values(this.stepAnswers).forEach((stepAnswer) => {
        Object.keys(stepAnswer).forEach((key) => {
          if (stepAnswer[key].length) {
            answers[key] = stepAnswer[key];
          }
        });
      });

      // Repeating a filter's param name with different values OR-matches
      // them natively (this is how Shopify's own checkbox filters submit
      // multiple selections for one filter), so an answer that lists several
      // filter values just appends each as its own param.
      const params = new URLSearchParams();
      Object.keys(paramMap).forEach((key) => {
        const paramName = paramMap[key];
        const values = answers[key] || [];
        if (paramName) {
          values.forEach((value) => params.append(paramName, value));
        }
      });

      const query = params.toString();
      window.location.href = query ? `${baseUrl}?${query}` : baseUrl;
    }
  }

  customElements.define('gift-finder-quiz', GiftFinderQuiz);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-image-compare"] && !Shopify.designMode) return;
  try {
    
  class ImageCompare extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="range"]');
      if (!this.input) return;

      const startPoint = parseFloat(this.dataset.startPoint);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.input.addEventListener('input', () => this.setExposure(this.input.value));
      this.input.addEventListener('change', () => this.setExposure(this.input.value));

      if (reduceMotion) {
        this.setExposure(startPoint);
        this.input.value = startPoint;
        this.setAttribute('animated', '');
        return;
      }

      const restPoint = startPoint - 15;
      this.setExposure(restPoint);
      this.input.value = restPoint;

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.animateReveal(restPoint, startPoint);
        },
        { threshold: 0.6 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    setExposure(value) {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        this.style.setProperty('--exposure', `${value}%`);
      });
    }

    animateReveal(from, to) {
      const duration = 1000;
      const start = performance.now();

      const easeInOutBack = (x) => {
        const c1 = 1.70158;
        const c2 = c1 * 1.525;
        return x < 0.5
          ? ((2 * x) ** 2 * ((c2 + 1) * 2 * x - c2)) / 2
          : (((2 * x - 2) ** 2 * ((c2 + 1) * (x * 2 - 2) + c2)) + 2) / 2;
      };

      const step = (now) => {
        const elapsed = Math.min((now - start) / duration, 1);
        const value = from + (to - from) * easeInOutBack(elapsed);

        this.style.setProperty('--exposure', `${value}%`);
        this.input.value = value;

        if (elapsed < 1) {
          this.animationFrame = requestAnimationFrame(step);
        } else {
          this.setAttribute('animated', '');
        }
      };

      this.animationFrame = requestAnimationFrame(step);
    }
  }

  if (!customElements.get('image-compare')) {
    customElements.define('image-compare', ImageCompare);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-media-spotlight"] && !Shopify.designMode) return;
  try {
    
  class MediaToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.media-spotlight__toggle');
      this.videoHost = this.querySelector('lazy-video');
      if (!this.button || !this.videoHost) return;

      this.button.hidden = true;
      this.button.addEventListener('click', () => this.toggle());

      const existingVideo = this.videoHost.querySelector('video');
      if (existingVideo) {
        this.bindVideo(existingVideo);
        return;
      }

      this.observer = new MutationObserver(() => {
        const video = this.videoHost.querySelector('video');
        if (video) {
          this.observer.disconnect();
          this.bindVideo(video);
        }
      });
      this.observer.observe(this.videoHost, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    bindVideo(video) {
      this.video = video;
      this.button.hidden = false;
      video.addEventListener('play', () => this.updateLabel());
      video.addEventListener('pause', () => this.updateLabel());
      this.updateLabel();
    }

    toggle() {
      if (!this.video) return;
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    }

    updateLabel() {
      const isPlaying = !this.video.paused;
      this.button.textContent = isPlaying ? this.button.dataset.pauseLabel : this.button.dataset.playLabel;
    }
  }

  if (!customElements.get('media-toggle')) {
    customElements.define('media-toggle', MediaToggle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-multi-column-icons"] && !Shopify.designMode) return;
  try {
    
  class IconGridScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-icon-grid-track]');
      this.thumb = this.querySelector('[data-icon-grid-thumb]');
      if (!this.track || !this.thumb) return;

      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.update);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const size = scrollWidth > 0 ? clientWidth / scrollWidth : 1;
      const maxScroll = scrollWidth - clientWidth;
      const progress = maxScroll > 0 ? scrollLeft / maxScroll : 0;

      // Hide the bar when everything already fits (e.g. tablet/desktop grid)
      this.classList.toggle('is-static', maxScroll <= 1);
      this.thumb.style.setProperty('--thumb-size', size);
      // Offset is a share of the thumb's own width, so it ends flush with the track
      this.thumb.style.setProperty('--thumb-offset', size < 1 ? (progress * (1 - size)) / size : 0);
    }
  }

  if (!customElements.get('icon-grid-scroller')) {
    customElements.define('icon-grid-scroller', IconGridScroller);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    
  class StickyBuyBar extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.sticky-buy-bar');
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.measure();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    measure() {
      const wasStuck = this.bar.classList.contains('is-stuck');
      if (wasStuck) {
        this.bar.classList.remove('is-stuck');
        this.style.height = '';
      }

      this.naturalTop = this.getBoundingClientRect().top + window.scrollY;
      this.barHeight = this.bar.offsetHeight;

      if (wasStuck) {
        this.bar.classList.add('is-stuck');
        this.style.height = `${this.barHeight}px`;
      }

      this.applyStuckState();
    }

    onResize() {
      this.measure();
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.applyStuckState();
        this.ticking = false;
      });
    }

    applyStuckState() {
      const shouldStick = window.scrollY >= this.naturalTop;
      if (shouldStick === this.bar.classList.contains('is-stuck')) return;
      this.bar.classList.toggle('is-stuck', shouldStick);
      this.style.height = shouldStick ? `${this.barHeight}px` : '';
    }
  }

  if (!customElements.get('sticky-buy-bar')) {
    customElements.define('sticky-buy-bar', StickyBuyBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-ugc-wall"] && !Shopify.designMode) return;
  try {
    
  class UgcWallScroller extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-ugc-scroller]');
      this.upButton = this.querySelector('[data-ugc-up]');
      this.downButton = this.querySelector('[data-ugc-down]');

      if (!this.scroller) return;

      this.onScroll = this.updateControls.bind(this);
      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
      this.upButton?.addEventListener('click', () => this.scrollByPage(-1));
      this.downButton?.addEventListener('click', () => this.scrollByPage(1));

      this.updateControls();
    }

    disconnectedCallback() {
      this.scroller?.removeEventListener('scroll', this.onScroll);
    }

    scrollByPage(direction) {
      this.scroller.scrollBy({ top: direction * this.scroller.clientHeight, behavior: 'smooth' });
    }

    updateControls() {
      const { scrollTop, scrollHeight, clientHeight } = this.scroller;
      const atStart = scrollTop <= 0;
      const atEnd = scrollTop + clientHeight >= scrollHeight - 1;

      if (this.upButton) this.upButton.disabled = atStart;
      if (this.downButton) this.downButton.disabled = atEnd;
    }
  }

  if (!customElements.get('ugc-wall-scroller')) {
    customElements.define('ugc-wall-scroller', UgcWallScroller);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-whats-in-the-box"] && !Shopify.designMode) return;
  try {
    
  class WhatsInBoxTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-whats-in-box-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-whats-in-box-panel]'));

      if (!this.tabs.length || !this.panels.length) return;

      this.panels.forEach((panel, index) => {
        panel.hidden = index !== 0;
      });

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index));
      });
    }

    activate(index) {
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });

      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });
    }
  }

  customElements.define('whats-in-box-tabs', WhatsInBoxTabs);

  } catch(e) { console.error(e); }
})();
})();
